module.exports = __webpack_public_path__ + "static/media/banner1.0a3f4f15.svg";